import React from "react";

const PricingComparison: React.FC = () => {
  const styles = {
    table: {
      width: "100%",
      color: "white",
      fontFamily: "Arial, sans-serif",
    },
    th: {
      backgroundColor: "transparent",
      color: "white",
      padding: "12px",
      textAlign: "left" as React.CSSProperties["textAlign"],
      fontSize: "18px",
    },
    td: {
      padding: "12px",
      border: "none",
      color: "white",
      textAlign: "left",
      backgroundColor: "transparent",
    },
    feature: {
      fontWeight: "bold",
    },
    logoCell: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    icon: {
      width: "15px",
    },
    iconCross: {
      width: "15px",
    },
    headerLogos: {
      width: "120px",
      verticalAlign: "middle",
    },
  };

  const check = (
    <img
      src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/check_icon.png"
      className="img-fluid"
      alt="Check"
      style={styles.icon}
    />
  );
  const cross = (
    <img
      src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/x_icon.png"
      className="img-fluid"
      alt="Cross"
      style={styles.iconCross}
    />
  );

  return (
    <table className="table ">
      <thead>
        <tr>
          <th
            style={
              {
                ...styles.th,
                ...styles.feature,
                color: "#fbd521",
              } as React.CSSProperties
            }
          >
            Feature
          </th>
          <th style={styles.th}>
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Flangoo_Library_WhiteStacked.png"
              alt="Flangoo Library"
              style={styles.headerLogos}
            />
          </th>
          <th style={styles.th}>
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Flangoo_Creator_WhiteStacked.png"
              alt="Flangoo Creator"
              style={styles.headerLogos}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {[
          ["Number of student accounts per teacher", "180", "180"],
          ["Access on any device—computer, phone, tablet, TV", check, check],
          ["Integrated quizzes", check, check],
          ["Audio narration", check, check],
          [
            "Hover-over vocab support for less common words and phrases",
            check,
            check,
          ],
          ["Use for independent or whole-class reading", check, check],
          ["Track students’ reading activity", check, check],
          ["New titles added every week", check, check],
          ["Spanish, French and German titles", check, check],
          [
            "Publish your own writing and multimedia (text, images, videos)",
            cross,
            check,
          ],
          [
            "Publish support materials for your content such as vocab help and quizzes",
            cross,
            check,
          ],
          [
            "Make content you create visible to select students or to all users",
            cross,
            check,
          ],
          ["Read and assign content added by other users", cross, check],
        ].map(([feature, library, creator], i) => (
          <tr key={i}>
            <td
              style={{
                ...styles.td,
                ...styles.feature,
                textAlign: styles.td
                  .textAlign as React.CSSProperties["textAlign"],
              }}
            >
              {feature}
            </td>
            <td
              style={{
                ...styles.td,
                textAlign: "center",
              }}
            >
              {library}
            </td>
            <td
              style={{
                ...styles.td,
                textAlign: styles.td
                  .textAlign as React.CSSProperties["textAlign"],
              }}
            >
              {creator}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PricingComparison;
